import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from "src/app/services/routing/navigator";
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-popover-dark-webview',
  templateUrl: './popover-dark-webview.component.html',
  styleUrls: ['./popover-dark-webview.component.scss'],
})
export class PopoverDarkWebviewComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public pageContent: any = "";
  public popOverTitle: string;

  constructor(
    public webContentService: WebcontentService,
    public navigator: Navigator,
  ) {
    this.popOverTitle = this.navigator.activePopovers[this.navigator.activePopovers.length - 1].componentProps.data.title;
  }

  ngOnInit() {
    const popoverUrl = (this.navigator.activePopovers[this.navigator.activePopovers.length - 1].componentProps.data.url);
    this.webContentService.updateExternalLink(popoverUrl);
  }

  closePopover() {
    this.pageContent = "";
    this.navigator.activePopovers[this.navigator.activePopovers.length - 1].dismiss();
  }
}
